.content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.selectContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
}

.select {
  width: 100%;
}

.assignButton {
  margin-top: 12px;
  height: 50px;
  display: flex;
}

.doneButton {
  width: 100%;
}

.drawerFooter {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  width: 100%;
  column-gap: 0.5rem;
  border-top: 1px solid var(--color-neutral-200);
  background-color: #fff;
  padding: 1rem 1.5rem;
}

.valueItem {
  display: flex;
  align-items: flex-start;
  border-radius: 4px;
  font-size: 14px;
  max-width: 290px;
}

.modalFooter {
  gap: 1rem;
}
